/**
 * @author wuTao
 * @description NEV认证详情页面配置
 * @Date 2022/04/29
 */
import React from 'react'
import {component_tool, utils_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import NevAuthEditor from "./nevAuthEditor";

let {$$, checkStrLength} = utils_tool;
const organization = WizTableForm.Config.organizationByNoFilter(this, {apiParams: {state: 1}});
const position = WizTableForm.Config.positionByNoFilter(this, {apiParams: {state: 1}});
const classInfoConfig = WizTableForm.Config.classInfo(this, {apiParams: {state: 1,isPower:false}});
const remoteAuthConfig = WizTableForm.Config.remoteAuth(this, {apiParams: {type: 2,isPower:false}});
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
let {WizModal, WizTimePicker} = component_tool;
const {RangePicker} = WizTimePicker;
let ref_;


//配置项
let componentName = 'nevRemoteAuthDetail'
const _columns = ({searchRemoteAuthName = ''}) => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    searchRemoteAuthName != null && searchRemoteAuthName != '' && searchRemoteAuthName != undefined ? {
      title: "检核项目",
      searchItem: {
        type: 'custom',
        render: () => {
          return <span>{searchRemoteAuthName}</span>
        }
      },
    } : {
      title: "检核项目",
      name: "remoteAuthIdList",
      searchItem: {
        ...remoteAuthConfig,
        diy: WizTableForm,
      },
    },
    {
      title: "认证场次",
      name: "searchName",
      searchItem: {},
    },
    {
      title: "姓名",
      name: "searchFullName",
      searchItem: {},
    },
    {
      title: "账号",
      name: "searchUserName",
      searchItem: {},
    },
    {
      title: "组织名称",
      name: "orgIdList",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "班级",
      name: "classIdList",
      searchItem: {
        ...classInfoConfig,
        diy: WizTableForm
      },
    },
    {
      title: '认证日期',
      name: 'openTime',
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "认证场次",
      name: "name",
      tableItem: {},
    },

    {
      title: "认证日期",
      name: "authDate",
      tableItem: {
        width: 120,
        render: (text, record) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "认证时间",
      tableItem: {
        width: 200,
        render: (text, record) => {
          const {startDate, endDate} = record;
          let authTimeStr = '';
          if (startDate != null && startDate != '' && endDate != null && endDate != '') {
            authTimeStr = formatterTime(startDate) + ' ~ ' + formatterTime(endDate);
          }
          return authTimeStr
        }
      },
    },
    {
      title: "分配状态",
      name: "distributionState",
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '未分配'},
        {code: 1, codeName: '已分配'},
      ],
      tableItem: {},
    },
    {
      title: "讲师",
      name: "lectureFullName",
      tableItem: {},
    },
    {
      title: "状态",
      name: "scoreState",
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 1, codeName: '待评分'},
        {code: 2, codeName: '已评分'},
        {code: 3, codeName: '未评分'},
      ],
    },
    {
      title: "状态",
      name: "scoreStateStr",
      tableItem: {},
    },
    {
      title: "总得分",
      name: "score",
      tableItem: {
        render: (text, record) => {
          return text === null && text < 0 ? '' : text
        }
      },
    },
    {
      title: "通过状态",
      name: "pass",
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "通过状态",
      name: "passStr",
      tableItem: {},
    }
  ];
}


const templateConfig = (data) => {
  const {self, name, jumpPageType} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: _columns({searchRemoteAuthName: name}),
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['openTime'] && value['openTime'].length === 2) {
              value['authStartDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD") + " 00:00:01";
              value['authEndDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD") + " 23:59:59";
            }else{
              value['authStartDate'] = undefined;
              value['authEndDate'] = undefined;
            }
            return value
          },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['authenticationSet','modifyScore','abilityRemote'],
        rowOperateView: [
          {
            key: 'authenticationSet',
            custom: true,
            params: {icon: "into", children: "认证设置", type: "info"},
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'nevAuthEditor_' + new Date().getTime(),
                modalParams: {
                  title: '认证设置',
                  style: {minWidth: 700},
                  diy: (e) => {
                    let editorProps = {
                      key: self.state.AddTimestamp,
                      editorSuccess: () => {
                        self.setState({AddTimestamp: new Date().getTime()})
                      },
                      ...e
                    }
                    return <NevAuthEditor {...editorProps}
                                          ref={(r) => {
                                            ref_ = r && r.getWrappedInstance();
                                          }}
                    />
                  },
                  onOk: () => {
                    ref_._ok();
                  },
                  onCancel: () => {
                    ref_._doInitParams();
                    self.setState({AddTimestamp: new Date().getTime()});
                  },
                  footer: false,
                  width: 680
                },
              },
              formatParams: (rows, record, filters, callback) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              const {scoreState, aideEndTime, distributionState} = record;
              let disabled = 0;
              let hidden = 0;
              if (distributionState === 1 && ((aideEndTime !=null && aideEndTime !='' && new Date().getTime() >= new Date(aideEndTime).getTime()) || (scoreState != null && scoreState === 2))) {
                disabled = 1;
                hidden = 1;
              }
              return {disabled: disabled, hidden: hidden}
            }
          },
          {
            key: "modifyScore",
            custom: true,
            params: {children: "去评分"},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/lectureNevAuthDetail/score',
                record: {jumpPageType: jumpPageType != null && jumpPageType != undefined && jumpPageType != '' ? jumpPageType : 'nevDetailList'}
              }
            },
            recordChangeParams: ({record, rows}) => {
              const {scoreState} = record;
              let disabled = 0;
              let hidden = 0;
              if (scoreState != null && scoreState === 2) {
                disabled = 1;
                hidden = 1;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
          {
            key: "abilityRemote",
            custom: true,
            params: {children: "能力认证模型"},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/nevRemoteAuthDetailList/score',
              }
            },
            recordChangeParams: ({record, rows}) => {
              const {scoreState} = record;
              let disabled = 0;
              let hidden = 0;
              if (scoreState != null && scoreState !== 2) {
                disabled = 1;
                hidden = 1;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
        ]
      }
    }
  }
};

const _apis = (data) => {
  const {remoteAuthId} = data;
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {remoteAuthId: remoteAuthId ? remoteAuthId : null, type: 2}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {remoteAuthId: remoteAuthId ? remoteAuthId : null, type: 2}
      }
    },
  }
}
let reduxTemplateCofig = (args) => {
  let {remoteAuthId} = args;
  return {
    apis: _apis({remoteAuthId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
